import { Routes } from '@angular/router';
import { RegistrierungComponent } from './registrierung/registrierung.component';
import { StartComponent } from './start/start.component';

export const routes: Routes = [
  {
    path: 'registrierung',
    component: RegistrierungComponent,
  },

  {
    path: 'registrierung/mitarbeiter/:uuid',
    component: RegistrierungComponent,
  },

  {
    path: 'registrierung/pruefer/:uuid',
    component: RegistrierungComponent,
  },

  {
    path: 'start',
    component: StartComponent,
  },
  {
    path: '',
    redirectTo: 'start',
    pathMatch: 'full',
  },
];
